import { Component, Input, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';

@Component({
  selector: 'app-sample-view-content',
  templateUrl: './sample-view-content.component.html',
  styleUrls: ['./sample-view-content.component.scss']
})
export class SampleViewContentComponent implements OnInit {


  @Input() blocks: any;
  @Input() lang: any;
  @Input() oggetto_view: string = '';
  public titlePage: string = '';
  public relatedData: any[] = [];
  public isLinkEsternal: boolean = false;
  public counterPage: number = 0;
  public viewMore = false;


  public customOptionsOwl: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    navSpeed: 700,
    autoWidth: false,
    autoHeight: false,
    dots: false,
    nav: true,
    navText: ['<i class="fa-solid fa-chevron-left" aria-hidden="true"></i>', '<i class="fa-solid fa-chevron-right" aria-hidden="true"></i>']
  };
  constructor(
    private nodeService: NodeService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.checkvariableInitComponent();
    this.setCarouselForType();
    this.getContentCategory();
  }

  private setCarouselForType(): void {
    switch (this.oggetto_view) {
      case 'news':
        this.customOptionsOwl = {
          ...this.customOptionsOwl,
          responsive: {
            0: {
              items: 1
            },
            600: {
              items: 2
            },
            900: {
              items: 3
            }
          }
        }
        break;
      case 'eventi':
        this.customOptionsOwl = {
          ...this.customOptionsOwl,
          responsive: {
            0: {
              items: 1
            },
            800: {
              items: 2
            }
          }
        }
        break;
      case 'avvisi':
        this.customOptionsOwl = {
          ...this.customOptionsOwl,
          responsive: {
            0: {
              items: 1
            },
            600: {
              items: 2
            },
            800: {
              items: 3
            }
          }
        }
        break;
      case 'pagine':
        this.customOptionsOwl = {
          ...this.customOptionsOwl,
          responsive: {
            0: {
              items: 1
            },
            600: {
              items: 3
            },
            800: {
              items: 4
            }
          }
        }
        break;
      case 'faq-procedure':
        this.customOptionsOwl = {
          ...this.customOptionsOwl,
          margin: 20,
          responsive: {
            0: {
              items: 1
            },
            600: {
              items: 3
            },
            1000: {
              items: 4
            }
          }
        }
        break;
      case 'docenti':
        this.customOptionsOwl = {
          ...this.customOptionsOwl,
          responsive: {
            0: {
              items: 1
            },
            600: {
              items: 3
            },
            800: {
              items: 4
            }
          }
        }
        break;
      default:
        break;
    }
  }

  private getContentCategory(): void {
    const queryParams = this.setQueryParams();
    this.nodeService.getViewCategories(this.lang,this.blocks.tipo_view,this.blocks.oggetto_view,queryParams).subscribe(res => {
      if (res.rows) {
        this.relatedData = res.rows;
        this.isMoreContent(res.pager);
      } else {
        this.relatedData = res;
      }
    });
  }

  private setQueryParams() {
    let filtererdSting: string = '';
    if(this.nodeService.viewFilters && this.nodeService.viewFilters[this.blocks.view_filter_id]) {
      const filters = this.nodeService.viewFilters[this.blocks.view_filter_id];
      for (let filter of filters) {
        if (this.blocks[filter.filter_name]) {
          filtererdSting += this.nodeService.setStringToViewFiltered(this.blocks[filter.filter_name], filter);
        }
      }
    }
    if(this.blocks.visualizza_come_carousel === 'On'){
      if (this.nodeService.lastChar(filtererdSting) === '&'){
        filtererdSting += 'items_per_page=All&';
      } else {
        filtererdSting += '&items_per_page=All';
      }
    }
    return filtererdSting;
  }

  private checkvariableInitComponent() {
    if (this.blocks.link) {
      this.isLinkEsternal = this.nodeService.verifyLinkExternal(this.blocks.link.url);
    }
    if (this.blocks.titolo) {
      this.titlePage = this.blocks.titolo;
    }
  }

  public addContentResult(): void {
    const queryParams = this.setQueryParams();
    this.nodeService.getViewCategories(this.lang,this.blocks.tipo_view,this.blocks.oggetto_view,queryParams, this.counterPage).subscribe(res => {
      if (res.rows) {
        this.relatedData = [
          ...this.relatedData,
          ...res.rows
        ];
        this.isMoreContent(res.pager);
      } else {
        this.relatedData = [
          ...this.relatedData,
          ...res
        ];
      }
    });
  }

  private isMoreContent(pager: any): void {
    if (((pager.current_page + 1) * pager.items_per_page) < Number(pager.total_items) ) {
      this.viewMore = true;
    } else {
      this.viewMore = false;
    }
    if ((this.counterPage <= pager.total_pages - 1)) {
      this.counterPage += 1;
    }
  }

}
